import { render, staticRenderFns } from "./ListaCompeticiones.vue?vue&type=template&id=38ff29b2&scoped=true"
import script from "./ListaCompeticiones.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListaCompeticiones.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ListaCompeticiones.vue?vue&type=style&index=0&id=38ff29b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ff29b2",
  null
  
)

export default component.exports